export default "__VITE_ASSET__B473LZso__"